type TGetShouldShowProjectsParams = {
  isCarouselShown: boolean;
  presaleProps?: unknown;
};

export const getShouldShowProjects = ({
  isCarouselShown,
  presaleProps,
}: TGetShouldShowProjectsParams): boolean => isCarouselShown || Boolean(presaleProps);
